import { getBranchId, getHospitalId, getLoginID } from "../../../auth";
import FetchData from "../../client";

export const FetchMasterTransferReportByPharmacy = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_gettransferreport", inputData);
    console.log(result, "MasterTransferReportByPharmacy Result");
    if (result.output) {
      return result.output;
    }
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};
export const FetchFilteredMasterTransferReportByPharmacy = async (inputData) => {
  try {
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_gettransferreport", inputData);
    console.log(result, "MasterTransferReportByPharmacy Result");
    if (result.output) {
      return result.output;
    }
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};

export const FetchTransferReportByPharmacy = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData("midoc_getpharmacytransferreport", inputData);
    // console.log(result, "FetchTransferReportByPharmacy Result");
    if (result.output) {
      return result.output;
    }
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};
